import styled from 'styled-components'
import { OrangeColor, backgroundDocument, GrayColor, GrayLight, White } from '../../constants/constants'
import { Button, Table } from 'antd'
import { Pencil } from '@styled-icons/evil/Pencil'
import { ClipboardCheck } from '@styled-icons/bootstrap/ClipboardCheck'
import { FileEarmarkPdf } from '@styled-icons/bootstrap/FileEarmarkPdf'
export const ProfileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${White};
  padding-bottom: 20px;
  width: 100%;
  max-width: 100vw;
  height: auto;
  @media (min-width: 768px) {
    height: auto;
  }
  height: auto;
  margin: 0px auto;
  margin-bottom: 20px;
`
export const CompanyProfile = styled.div`
  margin-top: 20px;
  font-size: 10pt;
  color: ${GrayColor};
  font-weight: bold;
`

export const HeaderProfileWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 50px;
`

export const EmployeeName = styled.div`
  display: flex;
  flex-direction: row;
  font-weight: bold;
  color: ${OrangeColor};
  font-size: 1rem;
  @media (min-width: 768px) {
    font-size: 20pt;
  }
`

export const RoleDegree = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 16pt;
  margin-top: 15px;
`

export const Line = styled.hr`
  margin-top: 40px;
  margin-bottom: 50px;
  border: 1px solid ${OrangeColor};
  background-color: ${OrangeColor};
  width: 100%;
  margin-left: 0px;
`

export const InfoWrapper = styled.div`
  display: flex;
  @media (max-width: 600px) {
    flex-direction: column-reverse;
  }
  flex-direction: row;
  width: 100%;
  flex-basis: 100%;
  flex: 1;
`

export const InfoColum1 = styled.div`
  height: auto;
  @media (max-width: 600px) {
    width: 100%;
  }
  width: 40%;
`
export const InfoColum2 = styled.div`
  height: auto;
  @media (max-width: 600px) {
    width: 100%;
  }
  width: 60%;
`

export const BoldText = styled.div`
  font-weight: bold;
  color: ${(props) => (props.color ? props.color : 'black')};
  margin-bottom: 25px;
`

export const ProfessionalExperienceTitle = styled.div`
  font-weight: bold;
  color: ${GrayColor};
  margin-top: 70px;
`

export const DivForMeasure = styled.div``

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const ButtonAntd = styled(Button)`
  background-color: ${backgroundDocument};
  border-bottom: none;
  font-weight: bold;
`
export const PencilButton = styled(Pencil)`
  color: ${GrayLight};
  margin-left: -10px;
  margin-bottom: 3px;
`
export const AuditButton = styled(ClipboardCheck)`
  color: ${GrayLight};
  margin-left: -10px;
  margin-bottom: 3px;
`
export const FileEarmarkPdfIcon = styled(FileEarmarkPdf)`
  color: ${GrayLight};
  margin-left: -10px;
  margin-right: 2px;
  margin-bottom: 5px;
`
export const AuditTableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  .ant-table-wrapper {
    overflow-x: auto;
  }
`
export const AntTable = styled(Table)`
  .ant-table {
    background-color: ${backgroundDocument};
  }
  .expanded-row {
   
  }
  .expanded-row__key{
    flex: 1;
  }
  .expanded-row__values{
    display:flex
    flex-direction: column;
  }
  .expanded-row__old{
    flex: 1;
  }
  .expanded-row__new{
    flex: 1;
  }
  @media (max-width: 768px) {
      
  }   
`
export const PreContainer = styled.div`
  font-size: 12px;
  @media (min-width: 768px) {
    font-size: 16px;
  }
`
export const ActionButtons = styled.div`
  margin-left: auto;
`
